import { green, red } from "@material-ui/core/colors";

import MeditocHelper from "../../../utils/MeditocHelper";
import RedeemIcon from "@material-ui/icons/Redeem";

export default function CuponHelper() {
    return (
        <MeditocHelper title="Estatus de cupón:">
            <div>
                <RedeemIcon style={{ color: green[500], verticalAlign: "middle" }} />
                {"  "}
                Cupón activo
            </div>
            <div>
                <RedeemIcon style={{ color: red[500], verticalAlign: "middle" }} />
                {"  "}
                Cupón inactivo
            </div>
        </MeditocHelper>
    );
}
